import produce from 'immer';
import { DateTime } from 'luxon';
import { PRODUCTS } from '../constants';
import { SET_ANOTHER_PERIOD, TOGGLE_LOADING, UPDATE_WINNINGS, SET_PRODUCT, SET_ERROR } from './actions';

const fromDate = DateTime.local()
    .minus({ days: 7 })
    .startOf('day')
    .toJSDate();
const untilDate = DateTime.local()
    .minus({ days: 1 })
    .endOf('day')
    .toJSDate();

export const defaultState = {
    winLoss: {},
    transactions: [],
    isLoading: true,
    product: PRODUCTS.ALL,
    from: fromDate,
    until: untilDate,
    error: '',
    isFetchError: false
};

export const reducer = (reducerSuffix) => produce((draftState, action) => {
    switch (action.type) {
        case SET_ANOTHER_PERIOD:
        case SET_ANOTHER_PERIOD + reducerSuffix: {
            const { from, until } = action.payload;

            Object.assign(draftState, {
                from,
                until
            });

            break;
        }

        case SET_PRODUCT:
        case SET_PRODUCT + reducerSuffix: {
            Object.assign(draftState, {
                product: action.payload
            });

            break;
        }

        case UPDATE_WINNINGS:
        case UPDATE_WINNINGS + reducerSuffix: {
            const { transactions, winLoss } = action.payload;

            Object.assign(draftState, {
                winLoss,
                transactions
            });

            break;
        }

        case TOGGLE_LOADING:
        case TOGGLE_LOADING + reducerSuffix: {
            Object.assign(draftState, {
                isLoading: action.payload
            });

            break;
        }

        case SET_ERROR:
        case SET_ERROR + reducerSuffix: {
            const { error, isFetchError } = action.payload;

            Object.assign(draftState, {
                error,
                isFetchError
            });

            break;
        }

        default: {
            break;
        }
    }
}, defaultState);
